import type { SystemIconType } from '@fiverr-private/visuals';
import type { SizeType } from '../IconButton/types';

interface IconColors {
    light: SystemIconType['color'];
    dark: SystemIconType['color'];
}

export const ICON_SIZES: { [key in SizeType]: SystemIconType['size'] } = {
    '3xs': 'sm',
    '2xs': 'sm',
    xs: 'sm',
    sm: 'md',
    md: 'md',
    lg: 'md',
} as const;

export const ICON_COLORS: IconColors = {
    light: 'grey_300',
    dark: 'grey_1200',
} as const;
